import { useEffect, useRef, useState } from "react";
const useSticky = (options = {})=>{
    const ref = useRef(null);
    const [isSticky, setIsSticky] = useState(true);
    const [isTop, setIsTop] = useState(true);
    const { root, rootMargin = '0%', topOffset = 1, onStickyChange } = options;
    useEffect(()=>{
        if (!ref.current || void 0 === root) return;
        const observer = new IntersectionObserver(([event])=>setIsTop(event.intersectionRatio < 1), {
            threshold: 1,
            root,
            rootMargin: `-${topOffset}px 0px 0px 0px`
        });
        observer.observe(ref.current);
        return ()=>observer.disconnect();
    }, [
        root,
        topOffset
    ]);
    useEffect(()=>{
        if (!ref.current || void 0 === root) return;
        const observer = new IntersectionObserver(([event])=>{
            const newIsSticky = 1 === event.intersectionRatio;
            setIsSticky(newIsSticky);
            null == onStickyChange || onStickyChange(newIsSticky);
        }, {
            threshold: 1,
            root,
            rootMargin
        });
        observer.observe(ref.current);
        return ()=>observer.disconnect();
    }, [
        root,
        rootMargin,
        onStickyChange
    ]);
    return {
        ref,
        isTop,
        isSticky
    };
};
export { useSticky };
